import React from 'react';

const About = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-4xl font-bold mb-6">About ContractGuard</h1>

          <p className="text-gray-600 text-lg mb-6">
            ContractGuard is an AI-powered contract analysis platform built to help individuals and
            businesses understand their contracts quickly and clearly — without needing a lawyer for
            every document.
          </p>

          <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
          <p className="text-gray-600 mb-6">
            Legal documents can be complex, confusing, and costly to review. Our mission is to make
            contract analysis accessible to everyone — from freelancers reviewing client agreements
            to small businesses evaluating supplier contracts.
          </p>

          <h2 className="text-2xl font-bold mb-4">What We Do</h2>
          <p className="text-gray-600 mb-4">
            We use advanced AI to analyse contracts and highlight:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
            <li>Risky or unusual clauses</li>
            <li>Missing standard protections</li>
            <li>Key obligations and deadlines</li>
            <li>Potential red flags</li>
            <li>Overall risk score and summary</li>
          </ul>

          <h2 className="text-2xl font-bold mb-4">Important Disclaimer</h2>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-gray-700 text-sm">
              ContractGuard is an informational tool only and does not constitute legal advice.
              Always consult with a qualified solicitor or lawyer before making any legal decisions
              or signing any contracts.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
